export const formatAmount = (value) => {
  if (value === null || value === undefined) return "";
  return Number(value).toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};